import _ from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FiArrowRightCircle } from 'react-icons/fi';
import CardH from 'src/components/cards/card-h';
import CardV from 'src/components/cards/card-v';
import Carousels from 'src/components/carousels';
import Image from 'src/components/image';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import styled from 'styled-components';
import useVideoIframe from './section-schneider/utils';

const SectionPTTVer2 = ({ data, pttVideo, eventDataLayer }) => {
  if (_.isEmpty(data)) return null;
  const allData = {
    item1: convertDatasets(data.dataSet, 'building', true),
    item2: convertDatasets(data.dataSet, 'background', true),
    item3: convertDatasets(data.dataSet, 'tag', true),
    item4: convertDatasets(data.dataSet, 'tag-video', true),
    item5: convertDatasets(data.dataSet, 'icon-ptt', true),
    item6: convertDatasets(data.dataSet, 'icon-good-news', true),
    item7: convertDatasets(data.dataSet, 'background-mobile', true)
  };
  const [resDataTag, setResDataTag] = useState();
  const [resDataTagVideo, setResDataTagVideo] = useState();
  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        if (!_.isEmpty(allData)) {
          const res = await Promise.all([
            GET(`/api/search/tag${convertObjPath({ name: allData?.item3 })}&limit=4`, false, true),
            GET(`/api/search/video/tag${convertObjPath({ name: allData?.item4 })}&limit=6`, false, true)
          ]);
          if (!_.isEmpty(res[0])) setResDataTag(_.uniqBy(res[0].data, 'id'));
          if (!_.isEmpty(res[1].data)) setResDataTagVideo(res[1].data);
        }
      } catch (err) {
        console.error(`${timestamp()} ==========> EVENT_ELECTION-2566 ERROR :`, err?.message);
      }
    })();
  }, []);
  return (
    <SectionWrapper id='section-ptt-ver.2' background={allData?.item2} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }} >
      {!_.isEmpty(allData?.item6) && (
        <div className='icon-good-news'>
          <Image image={allData?.item6} external={true} title={'icon-good-news'} type='CARD_MEDIUM' />
        </div>
      )}
      {!_.isEmpty(allData?.item5) && (
        <div className='icon-ptt'>
          <Image image={allData?.item5} external={true} title={'icon-ptt'} type='CARD_MEDIUM' />
        </div>
      )}
      <div className='container'>
        {!_.isEmpty(allData?.item1) && (
          <div className='building'>
            <Image image={allData?.item1} external={true} title={'building'} type='COVER_IMAGE' />
          </div>
        )}
        <div className='all-item'>
          <div className='godji'>
            <Image image={`${APP_IMG}/gif/godji.gif`} external={true} title={'building'} type='CARD_SMALL' />
          </div>
          <div className='content'>
            {!_.isEmpty(resDataTagVideo) && (
              <div className='left-content'>
                <div className='carousels-video'>
                  <Carousels slideShow={1} showDots={true} responsiveShow={1} infinite={false}>
                    {!_.isEmpty(resDataTagVideo) && _.map(resDataTagVideo?.slice(0, 1), (el, i) => (
                      <div key={i} className={`item-video --${i + 1}`}>
                        {useVideoIframe(el)}
                      </div>
                    ))}
                  </Carousels>
                  <div className='title-video'>
                    <span>{allData?.item4}</span>
                  </div>
                </div>
                  {!_.isEmpty(resDataTagVideo.slice(1, 2)) && (
                    <CardH
                      data={resDataTagVideo.slice(1, 2)[0]}
                      external={true}
                      eyeBall={false}
                      showFooter={false}
                      isVideo={true}
                      showReadmore={true}
                      //! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'section-ptt',
                        position: 'ใต้: section-schneider',
                        data: {
                          title: resDataTagVideo.slice(1, 2)[0]?.title,
                          heading: 'วีดีโอ-section-ptt',
                          index: 1
                        }
                      }}
                    />
                  )}
              </div>
            )}
            {!_.isEmpty(resDataTag) && (
              <div className='right-content'>
                <a href={`/tags/${allData?.item4}`} className='more'>
                  ดูทั้งหมด <FiArrowRightCircle />
                </a>
                {resDataTag?.slice(0, 2).map((item, index) => (
                  <div key={item.id}>
                    <CardV
                      data={item}
                      description={false}
                      path={item.link}
                      nonePadding={true}
                      isSmall={true}
                      cardV={false}
                      badge={true}
                      withTarget={true}
                      showFooter={false}
                      //! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'section-ptt',
                        position: 'ใต้: section-schneider',
                        data: {
                          title: item?.title,
                          heading: 'ข่าว-section-ptt',
                          index: index + 1
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='windmill'>
            <Image image={`${APP_IMG}/gif/windmill.gif`} external={true} title={'building'} type='CARD_SMALL' />
          </div>
        </div>
      </div>
      {!_.isEmpty(resDataTagVideo) &&
      <div className='content-mobile'>
        <img src={allData?.item7} className='background-mobile' />
        <div className='wrapper'>
          <div className='carousels-video'>
            <Carousels slideShow={1} showDots={true} responsiveShow={1} infinite={false}>
              {_.map(resDataTagVideo.slice(0, 1), (el, i) => (
                <div key={i} className={`item-video --${i + 1}`}>
                  {useVideoIframe(el)}
                </div>
              ))}
            </Carousels>
            <div className='title-video'>
              <span>{allData?.item4}</span>
            </div>
          </div>
          <div className='card-video-wrapper'>
            {!_.isEmpty(resDataTagVideo?.slice(1, 3)) && resDataTagVideo.slice(1, 3).map((item, index) => (
                <CardV
                data={item}
                description={false}
                path={item.link}
                nonePadding={true}
                isSmall={true}
                cardV={false}
                badge={true}
                withTarget={true}
                showFooter={false}
                isVideo={true}
                external={true}
                showReadmore={true}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-ptt',
                  position: 'ใต้: section-schneider',
                  data: {
                    title: item?.title,
                    heading: 'ข่าว-section-ptt',
                    index: index + 1
                  }
                }}
              />
            ))}
          </div>
          <a href={`/tags/${allData?.item4}`} className='more'>
            ดูทั้งหมด <FiArrowRightCircle />
          </a>
        </div>
      </div>}
    </SectionWrapper>
  );
};

const SectionWrapper = styled.div`
  background-image: url(${props => props.background});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-color: #fff;
  @media (max-width: 992px) {
    background-image: unset;
  }
  .content-mobile {
    display: none;
    @media (max-width: 992px) {
      display: block;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: auto;
      .background-mobile {
        width: 100%;
        display: none;
        @media (max-width: 992px) {
          display: block;
        }
      }
      .wrapper {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 47%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 10px 15px;
        width: 90%;
        background: linear-gradient(0deg, rgba(58, 53, 139, 0.8) 0%, rgba(0, 165, 215, 0.8) 100%);
        border-radius: 12px;
        .carousels-video {
          width: 100%;
          background: linear-gradient(90deg, rgba(58, 53, 139, 1) 0%, rgba(0, 165, 215, 1) 100%);
          padding: 0 0 10px 0;
          margin-bottom: 5px;
          border-radius: 12px;
          .carousel-wrapper {
            margin:  0 0 30px 0px;
          }
          .slick-list {
            border-radius: 12px;
          }
          .title-video {
              text-align: center;
              color: #fff;
              font-size: 18px;
              font-weight: 500;
            }
        }
        .card-video-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .card-wrapper {
            width: 48%;
            padding: 0 5px;
            .card-v-thumb  {
              margin-bottom: 10px;
            }
            .icon {
              color: #fefefe;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 40px;
            }
            .card-v-content-title {
              font-size: 16px;
              color: #fff;
              -webkit-line-clamp: 2;
        
            }
            .read-more {
              color: #F89522;
              font-size: 14px;
            }
          }
        }
        .more {
          align-self: flex-end;
          color: #fff;
        }
      }
    }
  }
  
  .icon-good-news {
    position: absolute;
    width: 250px;
    height: auto;
    left: 0;
    @media (max-width: 992px) {
      display: none;
    }
  }
  .icon-ptt {
    right: 0;
    position: absolute;
    width: 180px;
    height: auto;
    @media (max-width: 992px) {
      display: none;
    }
  }
  .container {
    position: relative;
    min-height: 400px;
    @media (max-width: 992px) {
      display: none;
    }
    .building {
      position: absolute;
      bottom: 0;
      width: 100%;
      @media (max-width: 992px) {
      display: none;
    }
    }
    .all-item {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-left: 40px;
      min-height: 400px;

      .godji {
        z-index: 1;
        width: 18%;
        height: auto;
        @media (max-width: 992px) {
          display: none;
        }
      }
      .content {
        z-index: 1;
        width: 60%;
        margin: 70px 0px 45px 10px;
        padding-left: 40px;
        display: flex;
        gap: 20px;
        .left-content {
          width: 55%;
          background: linear-gradient(0deg, rgba(58, 53, 139, 0.8) 0%, rgba(0, 165, 215, 0.8) 100%);
          padding: 12px;
          border-radius: 12px;
          .carousels-video {
            background: linear-gradient(90deg, rgba(58, 53, 139, 1) 0%, rgba(0, 165, 215, 1) 100%);
            /* border-radius: 12px; */
            padding: 6px;
            .title-video {
              text-align: center;
              color: #fff;
              font-size: 18px;
              font-weight: 500;
            }
            .item-video {
              .resolution-dailymotion {
                padding-top: 60%;
              }
            }
            .carousel-wrapper {
              margin: 0;
              display: block;
              .slick-dots {
                bottom: 0 !important;
                top: 80%;
                button {
                  &:before {
                    font-size: 13px !important;
                    color: #a9a9a9 !important;
                    opacity: 1 !important;
                  }
                }
                .slick-active {
                  button {
                    &:before {
                      font-size: 15px !important;
                      color: #fff !important;
                      opacity: 1 !important;
                    }
                  }
                }
              }
            }
            
          } 
          .card-h {
            padding-top: 14px;
            width: 100%;
            .card-h-thumb {
              width: 50%;
              height: auto;
              max-width: none;
              margin-right: 0;
              position: relative;
              .icon {
                color: #fefefe;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 40px;
              }
              img {
                max-width: none;
              }
            }
            .card-h-content {
              width: 45%;
              margin-left: 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              h3 {
                height: 40px;
                color: #fff;
              }
              .read-more {
                font-weight: 500;
                margin-top: 10px;
                color: #00a5d7;
                font-size: 14px;
              }
            }
          }
        }
        .right-content {
          position: relative;
          width: 45%;
          background: linear-gradient(0deg, rgba(58, 53, 139, 0.8) 0%, rgba(0, 165, 215, 0.8) 100%);
          padding: 12px 20px 0 20px;
          @media (max-width: 1200px) {
            padding: 12px 10px 0 10px;
          }
          .more {
            position: absolute;
            top: -30px;
            right: 0;
            color: #0600E7;
          }
          border-radius: 12px;
          .card-v {
            min-height: 0px;
            margin-bottom: 10px;
            .card-v-thumb {
              margin-bottom: 8px;
            }
            .card-v-content-title {
              font-size: 16px;
              color: #fff;
              -webkit-line-clamp: 1;
              @media (max-width: 1200px) {
                font-size: 14px;
              }
            }
          }
        }
      }
      .windmill {
        width: 22%;
        height: 350px;
        margin-right: 10px;
        @media (max-width: 992px) {
          display: none;
        }
      }
    }
  }
`;

export default SectionPTTVer2;
